@if (steps().length) {
  <p-stepper
    [linear]="false"
    [value]="activeStep()">
    <p-step-list>
      @for (step of steps(); let index = $index; track index) {
        <p-step [value]="index">
          <ng-template #content>
            <div
              [class]="'step-container ' + (index | stepClasses: activeStep() : step)"
              [ngClass]="{
                'no-description': !(step.estimatedArrivalTime || step.actualArrivalTime) && step.arrivalTimeStatus == 'none',
                'no-time': !step.time
              }">
              @if (step.time) {
                <time class="step-time">{{ step.time }}</time>
              }
              <span
                class="step-number"
                [pTooltip]="index == activeStep() || (isClient && step.statusType?.toLowerCase() === 'visited') ? tooltipContent : ''"
                tooltipPosition="bottom"
                [autoHide]="false">
                {{ index + 1 }}
              </span>
              <ng-template #tooltipContent>
                <app-ride-timeline-tooltip [stop]="step"></app-ride-timeline-tooltip>
              </ng-template>
              @if (step.arrivalTimeStatus != "none" || step.estimatedArrivalTime || step.actualArrivalTime) {
                <div class="step-status">
                  @if (step.arrivalTimeStatus === "skipped") {
                    <i class="status-icon size-icon-sm icon-skip-forward-circle-solid border-neutral-base-secondary-color"> </i>
                    <label
                      for="statusDescription"
                      class="status-label">
                      {{ step.statusDescription }}
                    </label>
                  } @else {
                    <app-badge
                      [round]="false"
                      [value]="step.actualArrivalTime ? 'A' : 'E'"
                      [severityClass]="step.actualArrivalTime ? 'success' : 'secondary'">
                    </app-badge>
                    @if (step.actualArrivalTime) {
                      <label
                        for="statusDescription"
                        class="status-label"
                        >{{ step.actualArrivalTime }}
                        <span [ngClass]="{ 'text-danger-color': step.arrivalTimeStatus == 'late', 'text-success-color': step.arrivalTimeStatus == 'early' }">{{ step.statusDescription }}</span>
                      </label>
                    } @else {
                      <label
                        for="statusDescription"
                        class="status-label"
                        >{{ step.estimatedArrivalTime }}</label
                      >
                    }
                  }
                </div>
              }
            </div>
            <span [class]="'line line-start ' + (index | stepClasses: activeStep() : step)"></span>
            @if (index < steps().length - 1) {
              <span [class]="'line line-end ' + (index | stepClasses: activeStep() : step)"></span>
            }
          </ng-template>
        </p-step>
      }
    </p-step-list>
  </p-stepper>
}
